export function createIdleTimeoutManager(options: {
    getLastActivity: () => number;
    idleTimeoutMs: number;
    warningBeforeMs: number;
    onWarning: (countdown: number) => void;
    onIdle: () => void;
    onActive: () => void; // To dismiss warning if active again
    intervalMs?: number;
}) {
    let intervalId: ReturnType<typeof setInterval> | null = null;
    let isWarningActive = false;
    const intervalMs = options.intervalMs ?? 1000;

    function checkIdle() {
        const lastActivity = options.getLastActivity();
        const idleTime = Date.now() - lastActivity;
        
        // Ensure warning starts correctly even if threshold is exactly hit
        const warningThreshold = Math.max(0, options.idleTimeoutMs - options.warningBeforeMs);

        if (idleTime >= options.idleTimeoutMs) {
            // Idle timeout reached
            options.onIdle();
            isWarningActive = false; // Reset state 
        } else if (idleTime >= warningThreshold) {
            // In warning period
            isWarningActive = true;
            const remaining = Math.max(0, options.idleTimeoutMs - idleTime);
            options.onWarning(Math.ceil(remaining / 1000)); // countdown in seconds
        } else {
            // User is active and not in warning period
            if (isWarningActive) {
                isWarningActive = false;
                options.onActive();
            }
        }
    }

    return {
        start() {
            if (intervalId) return;
            intervalId = setInterval(checkIdle, intervalMs);
            // Run once immediately
            checkIdle();
        },
        stop() {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            isWarningActive = false;
        },
        getIdleTime() {
            return Date.now() - options.getLastActivity();
        },
        updateConfig(newIdleTimeoutMs: number, newWarningBeforeMs: number) {
            options.idleTimeoutMs = newIdleTimeoutMs;
            options.warningBeforeMs = newWarningBeforeMs;
        }
    };
}
